import React from 'react';
import SelectInput from './selectInput.jsx';

export default class CountryPhoneInput extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            value: this.clearValue(this.props.value),
            selectedCountry: this.props.defaultCountry || 'ru'
        };

        // Определяем список стран с их кодами и масками
        this.countries = [
            { value: 'ru', label: '🇷🇺 Россия', code: '+7', mask: '+7 (___) ___-__-__', maxLength: 18 },
            { value: 'kz', label: '🇰🇿 Казахстан', code: '+7', mask: '+7 (___) ___-__-__', maxLength: 18 },
            { value: 'by', label: '🇧🇾 Беларусь', code: '+375', mask: '+375 (__) ___-__-__', maxLength: 19 },
            { value: 'ua', label: '🇺🇦 Украина', code: '+380', mask: '+380 (__) ___-__-__', maxLength: 19 },
            { value: 'us', label: '🇺🇸 США', code: '+1', mask: '+1 (___) ___-____', maxLength: 17 },
            { value: 'ca', label: '🇨🇦 Канада', code: '+1', mask: '+1 (___) ___-____', maxLength: 17 },
            { value: 'gb', label: '🇬🇧 Великобритания', code: '+44', mask: '+44 ____ ______', maxLength: 17 },
            { value: 'de', label: '🇩🇪 Германия', code: '+49', mask: '+49 ___ _______', maxLength: 17 },
            { value: 'fr', label: '🇫🇷 Франция', code: '+33', mask: '+33 _ __ __ __ __', maxLength: 17 },
            { value: 'it', label: '🇮🇹 Италия', code: '+39', mask: '+39 ___ _______', maxLength: 17 },
            { value: 'es', label: '🇪🇸 Испания', code: '+34', mask: '+34 ___ ___-___', maxLength: 16 },
            { value: 'cn', label: '🇨🇳 Китай', code: '+86', mask: '+86 ___ ____-____', maxLength: 18 },
            { value: 'jp', label: '🇯🇵 Япония', code: '+81', mask: '+81 __-____-____', maxLength: 17 },
            { value: 'in', label: '🇮🇳 Индия', code: '+91', mask: '+91 _____ _____', maxLength: 16 },
            { value: 'br', label: '🇧🇷 Бразилия', code: '+55', mask: '+55 (__) _____-____', maxLength: 19 },
            { value: 'au', label: '🇦🇺 Австралия', code: '+61', mask: '+61 ___ ___ ___', maxLength: 16 },
            { value: 'other', label: '🌍 Другая страна', code: '+', mask: '+___ ___________', maxLength: 20 }
        ];
    }

    componentWillReceiveProps(newProps) {
        let value = this.clearValue(newProps.value);
        this.setState({ value: value });

        // Если передается новая страна по умолчанию
        if (newProps.defaultCountry && newProps.defaultCountry !== this.state.selectedCountry) {
            this.setState({ selectedCountry: newProps.defaultCountry });
        }
    }

    clearValue(value) {
        if (!value) {
            return "";
        }
        return value.toString();
    }

    getCurrentCountryInfo() {
        return this.countries.find(c => c.value === this.state.selectedCountry) || this.countries[0];
    }

    formatPhoneNumber(value, countryInfo) {
        if (!value) return countryInfo.code;
        
        // Убираем все, кроме цифр
        let cleaned = value.replace(/\D/g, '');
        
        // Удаляем код страны из начала, если он есть
        const codeDigits = countryInfo.code.replace(/\D/g, '');
        if (cleaned.startsWith(codeDigits)) {
            cleaned = cleaned.substring(codeDigits.length);
        }

        let formatted = countryInfo.code;
        
        if (countryInfo.value === 'ru' || countryInfo.value === 'kz') {
            // +7 (999) 999-99-99
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 3)}`;
                if (cleaned.length > 3) {
                    formatted += `) ${cleaned.substring(3, 6)}`;
                    if (cleaned.length > 6) {
                        formatted += `-${cleaned.substring(6, 8)}`;
                        if (cleaned.length > 8) {
                            formatted += `-${cleaned.substring(8, 10)}`;
                        }
                    }
                }
            }
        } else if (countryInfo.value === 'us' || countryInfo.value === 'ca') {
            // +1 (999) 999-9999
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 3)}`;
                if (cleaned.length > 3) {
                    formatted += `) ${cleaned.substring(3, 6)}`;
                    if (cleaned.length > 6) {
                        formatted += `-${cleaned.substring(6, 10)}`;
                    }
                }
            }
        } else if (countryInfo.value === 'by') {
            // +375 (99) 999-99-99
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 2)}`;
                if (cleaned.length > 2) {
                    formatted += `) ${cleaned.substring(2, 5)}`;
                    if (cleaned.length > 5) {
                        formatted += `-${cleaned.substring(5, 7)}`;
                        if (cleaned.length > 7) {
                            formatted += `-${cleaned.substring(7, 9)}`;
                        }
                    }
                }
            }
        } else if (countryInfo.value === 'ua') {
            // +380 (99) 999-99-99
            if (cleaned.length > 0) {
                formatted += ` (${cleaned.substring(0, 2)}`;
                if (cleaned.length > 2) {
                    formatted += `) ${cleaned.substring(2, 5)}`;
                    if (cleaned.length > 5) {
                        formatted += `-${cleaned.substring(5, 7)}`;
                        if (cleaned.length > 7) {
                            formatted += `-${cleaned.substring(7, 9)}`;
                        }
                    }
                }
            }
        } else if (countryInfo.value === 'gb') {
            // +44 9999 999999
            if (cleaned.length > 0) {
                formatted += ` ${cleaned.substring(0, 4)}`;
                if (cleaned.length > 4) {
                    formatted += ` ${cleaned.substring(4, 10)}`;
                }
            }
        } else if (countryInfo.value === 'de') {
            // +49 999 9999999
            if (cleaned.length > 0) {
                formatted += ` ${cleaned.substring(0, 3)}`;
                if (cleaned.length > 3) {
                    formatted += ` ${cleaned.substring(3, 10)}`;
                }
            }
        } else if (countryInfo.value === 'fr') {
            // +33 9 99 99 99 99
            if (cleaned.length > 0) {
                formatted += ` ${cleaned.substring(0, 1)}`;
                if (cleaned.length > 1) {
                    formatted += ` ${cleaned.substring(1, 3)}`;
                    if (cleaned.length > 3) {
                        formatted += ` ${cleaned.substring(3, 5)}`;
                        if (cleaned.length > 5) {
                            formatted += ` ${cleaned.substring(5, 7)}`;
                            if (cleaned.length > 7) {
                                formatted += ` ${cleaned.substring(7, 9)}`;
                            }
                        }
                    }
                }
            }
        } else {
            // Для других стран простое форматирование
            if (cleaned.length > 0) {
                formatted += ` ${cleaned}`;
            }
        }
        
        return formatted;
    }

    handleCountryChange = (selection) => {
        const countryCode = selection ? selection.value : 'ru';
        const countryInfo = this.countries.find(c => c.value === countryCode) || this.countries[0];
        
        this.setState({ 
            selectedCountry: countryCode,
            value: countryInfo.code // Устанавливаем код страны
        });

        // Отправляем код страны как новое значение
        if (this.props.onChange) {
            this.props.onChange(countryInfo.code);
        }
    }

    handleInputChange = (e) => {
        const countryInfo = this.getCurrentCountryInfo();
        let value = e.target.value;
        
        // Разрешаем только цифры, +, (, ), -, и пробелы
        value = value.replace(/[^+\d\s\-\(\)]/g, '');
        
        // Проверяем, не является ли это вставкой номера с 8 (fallback для случаев, когда onPaste не сработал)
        if (countryInfo.value === 'ru' && value.includes('8') && !value.includes('+7')) {
            // Если в тексте есть 8 и нет +7, пытаемся заменить 8 на +7
            const cleaned = value.replace(/[^\d+]/g, '');
            if (cleaned.startsWith('8')) {
                value = '+7' + cleaned.substring(1);
            }
        }
        
        // Форматируем номер
        const formatted = this.formatPhoneNumber(value, countryInfo);
        
        this.setState({ value: formatted });
        
        if (this.props.onChange) {
            this.props.onChange(formatted || null);
        }
    }

    handlePaste = (e) => {
        e.preventDefault();
        
        const countryInfo = this.getCurrentCountryInfo();
        let pastedText = '';
        
        try {
            // Пытаемся получить данные из буфера обмена
            pastedText = e.clipboardData.getData('text');
        } catch (error) {
            console.warn('Не удалось получить данные из буфера обмена:', error);
            return;
        }
        
        if (!pastedText) {
            return;
        }
        
        // Очищаем вставленный текст от всех символов кроме цифр и +
        let cleaned = pastedText.replace(/[^\d+]/g, '');
        
        // Если выбран регион Россия и номер начинается с 8, заменяем на +7
        if (countryInfo.value === 'ru' && cleaned.startsWith('8')) {
            cleaned = '+7' + cleaned.substring(1);
        }
        
        // Если номер начинается с +7 и выбран регион Россия, оставляем как есть
        if (countryInfo.value === 'ru' && cleaned.startsWith('+7')) {
            // Оставляем как есть
        }
        // Если номер начинается с 7 и выбран регион Россия, добавляем +
        else if (countryInfo.value === 'ru' && cleaned.startsWith('7')) {
            cleaned = '+' + cleaned;
        }
        // Если номер не содержит код страны, добавляем код выбранной страны
        else if (!cleaned.startsWith('+')) {
            cleaned = countryInfo.code + cleaned;
        }
        
        // Форматируем номер
        const formatted = this.formatPhoneNumber(cleaned, countryInfo);
        
        this.setState({ value: formatted });
        
        if (this.props.onChange) {
            this.props.onChange(formatted || null);
        }
    }

    handleKeyDown = (e) => {
        // Разрешаем специальные клавиши
        const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
        ];
        
        if (allowedKeys.includes(e.key)) {
            return;
        }
        
        // Разрешаем Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X (работает на любой раскладке)
        if (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
            return;
        }
        
        // Универсальная проверка по коду клавиши (работает независимо от раскладки)
        if (e.ctrlKey && ['KeyA', 'KeyC', 'KeyV', 'KeyX'].includes(e.code)) {
            return;
        }
        
        // Дополнительная проверка для русской раскладки (Ctrl+М = Ctrl+V)
        if (e.ctrlKey && e.key === 'м') {
            return;
        }
        
        // Разрешаем только цифры
        if (!/\d/.test(e.key)) {
            e.preventDefault();
        }
    }

    handleBlur = () => {
        if (this.props.onEditComplete) {
            this.props.onEditComplete();
        }
    }

    handleFocus = (e) => {
        const countryInfo = this.getCurrentCountryInfo();
        // Если поле содержит только код страны, позиционируем курсор в конец
        if (this.state.value === countryInfo.code) {
            setTimeout(() => {
                e.target.setSelectionRange(e.target.value.length, e.target.value.length);
            }, 0);
        }
    }

    render() {
        const countryInfo = this.getCurrentCountryInfo();
        
        return (
            <div className="country-phone-input-wrapper">
                <div style={{ display: 'flex', gap: '8px' }}>
                    <div style={{ width: '200px', flexShrink: 0 }}>
                        <SelectInput
                            options={this.countries}
                            value={this.state.selectedCountry}
                            onChange={this.handleCountryChange}
                            disabled={this.props.disabled}
                            placeholder="Выберите страну"
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <input 
                            type="text"
                            className="form-control"
                            id={this.props.id}
                            title={this.props.title}
                            value={this.state.value}
                            placeholder={countryInfo.mask}
                            onChange={this.handleInputChange}
                            onKeyDown={this.handleKeyDown}
                            onPaste={this.handlePaste}
                            onBlur={this.handleBlur}
                            onFocus={this.handleFocus}
                            disabled={this.props.disabled}
                            maxLength={countryInfo.maxLength}
                        />
                    </div>
                </div>
                <small className="text-muted" style={{ fontSize: '11px', marginTop: '2px', display: 'block' }}>
                    Выберите страну и введите номер телефона
                </small>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./App/controls/countryPhoneInput.jsx